<template>
  <q-col :span="4">
    <q-aside />
  </q-col>
</template>

<script>
  import aside from '../aside'

  export default {
    name: "QAsideContainer",

    components: {
      'q-aside': aside,
    },
  }
</script>

<style scoped>

</style>